import { TextFieldProps } from '@mui/material';
import { type Control, Controller, type FieldValues, type Path, type RegisterOptions } from 'react-hook-form';
import { MaskedTextField } from '@/shared/ui/MaskedTextField';

type FormMaskedInputProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  control: Control<TFieldValues>;
  mask: string;
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
} & Omit<TextFieldProps, 'name' | 'defaultValue' | 'value' | 'onChange' | 'inputRef'>;

export const FormMaskedTextField = <TFieldValues extends FieldValues>({
  control,
  helperText,
  name,
  rules,
  ...props
}: FormMaskedInputProps<TFieldValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { ref, ...fieldProps }, fieldState: { error } }) => (
        <MaskedTextField
          {...props}
          {...fieldProps}
          fullWidth
          inputRef={ref}
          error={!!error}
          helperText={helperText ?? error?.message}
        />
      )}
    />
  );
};
